









import Vue from "vue";
import Component from "vue-class-component";
import { CentralNotificacoesService } from "@/services/central-notificacao.service";
import { Prop, Watch } from "vue-property-decorator";

interface ComboItem {
  text: string;
  value: number;
}

@Component
export default class ComboTipoEnvioNotificacao extends Vue {
  valid = false;
  tipo: ComboItem | null = null;
  items: ComboItem[] = [];
  loading = false;
  @Prop({ default: "Tipo de envio" }) label!: string;
  @Prop(Number) readonly value: number | undefined;

  @Watch("tipo")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.value);
  }

  fetchTipos() {
    this.loading = true;
    this.items = CentralNotificacoesService.listarTipoEnvioNotificacao();
    this.loading = false;
  }

  mounted() {
    this.fetchTipos();
  }
}
